export default __webpack_public_path__ + "static/media/infoTooltip.622862fc.svg";